import JwtService from "../../../core/services/JwtService";

export default {
  user: {},
  isAuthenticated: !!JwtService.getToken()
};
